import { Drawer, Spin, Flex } from "@/base/components/index";
import { MessageBoundary } from "@/components/message-boundary/components/message-boundary";
import { DrawerFormProps } from "../types";
import { useDrawerFormStyles } from "./drawer-form.styles";
import { cx } from "antd-style";

export const DrawerForm = ({
  open,
  onClose,
  title,
  footer,
  children,
  className,
  loading,
  destroyOnHidden = true,
}: DrawerFormProps) => {
  const { styles } = useDrawerFormStyles();
  return (
    <Drawer
      open={open}
      onClose={onClose}
      className={cx(styles.root, className)}
      destroyOnHidden={destroyOnHidden}
      title={title}
      footer={footer}
    >
      {loading && (
        <Flex justify="center" align="center" className={styles.loader}>
          <Spin size="large" />
        </Flex>
      )}

      <Flex vertical gap={12} align="stretch">
        <MessageBoundary level="modal" />
        {children}
      </Flex>
    </Drawer>
  );
};
